/**************************************************
 * Nombre:       Formulario_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {FlagOutlined, GeneratingTokensOutlined, Title} from "@mui/icons-material";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {CRYPTOS, ESTADOSSOPORTE} from "../../Constantes";
import {QRCodeSVG} from 'qrcode.react';
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";
import {copiarPortapapeles} from "../../CodigoCliente/Funciones/copiarPortapapeles";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";

const Formulario_Soporte = ({...props}) => {
    const {Avisos, nuevoAviso, terminar} = useCargador({logoRedondo: ''})

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Avisos/>

                <Grid container size={6}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOSSOPORTE.map((it) => it.nombre)}
                                   editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Title} nombre={'Asunto'} dato={'asunto'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Descripcion del inconveniente'} dato={'descripcion'} {...props}

                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{fontWeight: 600}}>Envio de Captura de Pantalla</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <IngresoImagen dato={'img'} {...props} />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 12}}>
                        Es necesario evidencias de lo dicho, porfavor envie capturas de pantalla o imagenes
                    </Typography>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Soporte